/**
@format
@flow
*/
import ActionTypes from '@ziynx/action-types';
import type { MediaState, MediaAction } from '@ziynx/flow-types/media';

const initialState: MediaState = {
  uploadsQueue: [],
  s3UploadsInProgress: [],
};

export default function reduceMedia(
  state: MediaState = initialState,
  action: MediaAction,
): MediaState {
  if (!action.type) {
    return state;
  }

  const { s3UploadsInProgress } = state;
  const { mediaUploadReference = {}, response } = action;
  const { uploadReferenceId, assetId = '' } = mediaUploadReference;

  switch (action.type) {
  case ActionTypes.media.getPresignedUrl.START:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: true,
          error: null,
          uploadStatus: 'in-progress',
        },
      },
    };
  case ActionTypes.media.getPresignedUrl.ERROR:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: false,
          uploadStatus: 'error',
        },
      },
    };
    /* Upload to s3 url */
  case ActionTypes.media.uploadMediaAsset.START:
    return {
      ...state,
      s3UploadsInProgress: [...s3UploadsInProgress, assetId],
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: true,
          error: null,
          uploadStatus: 'in-progress',
        },
      },
    };
  case ActionTypes.media.uploadMediaAsset.SUCCESS:
    return {
      ...state,
      uploadsQueue: [...(state?.uploadsQueue || []), uploadReferenceId],
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          uploadStatus: 'success',
        },
      },
    };
  case ActionTypes.media.uploadMediaAsset.ERROR:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: false,
          uploadStatus: 'error',
        },
      },
    };
    /** Checking s3 upload status */
  case ActionTypes.media.checkUploadStatus.START:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: true,
          error: null,
        },
      },
    };
  case ActionTypes.media.checkUploadStatus.SUCCESS: {
    const fetchingIds = (s3UploadsInProgress ?? []).filter(
      (id) => id !== assetId,
    );
    const newUploadsQueue = (state?.uploadsQueue ?? []).filter(
      (id) => id !== uploadReferenceId,
    );

    return {
      ...state,
      s3UploadsInProgress: fetchingIds,
      uploadsQueue: newUploadsQueue,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: false,
          sources: response?.sources,
        },
      },
    };
  }
  case ActionTypes.media.checkUploadStatus.ERROR: {
    const fetchingIds = (s3UploadsInProgress ?? []).filter(
      (id) => id !== uploadReferenceId,
    );
    const newUploadsQueue = (state?.uploadsQueue ?? []).filter(
      (id) => id !== uploadReferenceId,
    );

    return {
      ...state,
      s3UploadsInProgress: fetchingIds,
      uploadsQueue: newUploadsQueue,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          uploadStatus: 'error',
          fetching: false,
        },
      },
    };
  }
  case ActionTypes.media.editMediaAsset.START:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: true,
          uploadStatus: 'in-progress',
        },
      },
    };
  case ActionTypes.media.editMediaAsset.SUCCESS:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: false,
          uploadStatus: 'success',
        },
      },
    };
  case ActionTypes.media.editMediaAsset.ERROR:
    return {
      ...state,
      ...{
        [uploadReferenceId]: {
          ...(state[uploadReferenceId] ?? {}),
          ...(mediaUploadReference ?? {}),
          fetching: false,
          uploadStatus: 'error',
        },
      },
    };

  case ActionTypes.media.clearVideo:
    if (uploadReferenceId) {
      const { [uploadReferenceId]: value, ...rest } = state;
      return {
        ...rest,
      };
    }
    return initialState;
  case ActionTypes.media.clearImage:
    if (uploadReferenceId) {
      const { [uploadReferenceId]: value, ...rest } = state;
      return {
        ...rest,
      };
    }
    return initialState;
  default:
    return state;
  }
}
